import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Accordion } from '@mui/material';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';

import AssetRequest from '../../participant/requests/assetRequests/AssetRequest';
import FinancialRequest from '../../participant/requests/financialRequests/FinancialRequest';
import AccordionHeader from '../../ui/accordion/AccordionHeader';
import AccordionIcon from '../../ui/accordion/AccordionIcon';

const Requests = ({ isViewOnly = false }) => {
    const [expanded, setExpanded] = useState('');

    const onAccordionChange = (panel) => {
        setExpanded(expanded === panel ? '' : panel);
    };

    return (
        <div>
            <Accordion
                slotProps={{ transition: { mountOnEnter: true } }}
                expanded={expanded === 'financialRequests'}
                onChange={() => onAccordionChange('financialRequests')}>
                <AccordionSummary
                    expandIcon={<AccordionIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header">
                    <AccordionHeader>Financial Requests</AccordionHeader>
                </AccordionSummary>
                <AccordionDetails>
                    {expanded === 'financialRequests' && (
                        <FinancialRequest isViewOnly={isViewOnly} />
                    )}
                </AccordionDetails>
            </Accordion>
            <Accordion
                slotProps={{ transition: { mountOnEnter: true } }}
                expanded={expanded === 'assetRequests'}
                onChange={() => onAccordionChange('assetRequests')}>
                <AccordionSummary
                    expandIcon={<AccordionIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header">
                    <AccordionHeader>Asset Requests</AccordionHeader>
                </AccordionSummary>
                <AccordionDetails>
                    {expanded === 'assetRequests' && <AssetRequest isViewOnly={isViewOnly} />}
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

Requests.propTypes = {
    isViewOnly: PropTypes.bool
};

export default Requests;
